module.exports = __webpack_public_path__ + "img/ruby-profilepix.5a1aaee8.jpg";